import { Link } from "react-router-dom";
import { hotList } from "@/mocks/site";

export default function HomeHero() {
  const stats = [
    { label: "今日更新", value: "128 条" },
    { label: "在榜话题", value: "42 个" },
    { label: "网友参与", value: "36.8 万" },
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20artistic%20stage%20light%20bokeh%20over%20deep%20warm%20dark%20background%20with%20soft%20amber%20and%20coral%20glow%20cinematic%20editorial%20hero%20visual%20minimal%20composition&width=1600&height=900&seq=gossip-hero-01&orientation=landscape"
          alt="热搜吃瓜实时热点追踪主视觉"
          title="热搜吃瓜 - 实时热点追踪"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/85"></div>
      </div>

      <div className="relative mx-auto w-full px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex animate-fade-up items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs font-medium text-background-100 backdrop-blur">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            24 小时持续更新 · 出现新动向即时同步
          </span>

          <h1 className="mt-6 animate-fade-up font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl" style={{ animationDelay: "0.1s" }}>
            热搜吃瓜
            <span className="mt-3 block text-lg font-semibold text-accent-300 md:text-2xl">
              紧盯热搜最新进展与实时动态
            </span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl animate-fade-up text-sm leading-relaxed text-background-200 md:text-base" style={{ animationDelay: "0.2s" }}>
            首页按热度持续滚动补充新消息，把当天讨论度最高的话题集中在一处。不用反复刷屏，也能在第一时间跟上正在发生的吃瓜现场。
          </p>

          <div className="mt-8 flex animate-fade-up flex-col items-center justify-center gap-3 sm:flex-row" style={{ animationDelay: "0.3s" }}>
            <Link
              to="/rankings"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              </span>
              查看实时榜单
            </Link>
            <Link
              to="/articles"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              浏览今日动态
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </Link>
          </div>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 px-5 py-4 text-center backdrop-blur"
            >
              <p className="font-heading text-xl font-bold text-accent-300 md:text-2xl">{stat.value}</p>
              <p className="mt-1 text-xs text-background-200">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative border-t border-background-50/10 bg-foreground-950/40 backdrop-blur">
        <div className="mx-auto flex w-full items-center gap-3 px-4 py-3 md:px-6">
          <span className="shrink-0 text-xs font-semibold text-accent-300">热搜榜第 1 位</span>
          <Link
            to={`/article/${hotList[0].linkId}`}
            className="truncate text-sm text-background-100 transition-colors hover:text-accent-300"
          >
            {hotList[0].keyword}
          </Link>
          <span className="ml-auto hidden shrink-0 text-xs text-background-300 sm:block">{hotList[0].heat} 热度</span>
        </div>
      </div>
    </section>
  );
}